const SCHEMA_FIELD_OPERATIONS = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

export default SCHEMA_FIELD_OPERATIONS;
